
(function trackableCollectionModule() {

    angular.module('TrackableCollection', []);

})();